import { z } from "zod";

export const loginSchema = z.object({
  username: z.string().min(1, "El correo es requerido").email("Correo inválido"),
  password: z.string().min(1, "La contraseña es requerida"),
});
